import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },
    flag: {
      display: 'inline-block',
      minWidth: 100,
      color: palette.blue,
      textAlign: 'center',
      border: `1px solid ${palette.blue}`,
      borderRadius: 5,
      marginLeft: '10px',
      textTransform: 'capitalize',
    },
    flagRed: {
      color: palette.red,
      borderColor: palette.red,
    },
    flagNavOperator: {
      color: palette.navOperator,
      borderColor: palette.navOperator,
    },

    checkboxCell: {
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    version: { textAlign: 'center' },
    deleteText: { fontSize: 12, color: palette.darkGray },
    deleteTextDisable: {
      opacity: 0.5,
      cursor: 'default',
      fontSize: 12,
      color: palette.darkGray,
    },
  });
